import { TireIndustry } from "@/@types/Tire";
import { TireIndustryResponse } from "../tires/models/TireIndustryResponse";

export function mapTireIndustry(response: TireIndustryResponse[]): TireIndustry[] {
    return response.map(industry => ({
        name: industry.name,
        slug: industry.slug,
    }))
}